import type { AuthorizedResourceAccessMap } from '@/permissions/adapter';
import { ALL_PERMISSION_KEYS } from '@/permissions/definitions';

const buildAdminAccessMap = (
  baseAccess: AuthorizedResourceAccessMap,
): AuthorizedResourceAccessMap => {
  return ALL_PERMISSION_KEYS.reduce<AuthorizedResourceAccessMap>(
    (accumulator, key) => {
      accumulator[key] = true;
      return accumulator;
    },
    { ...baseAccess },
  );
};

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState:
    | {
        authorizedResourceAccess?: AuthorizedResourceAccessMap;
        currentTenantIsAdmin?: boolean;
      }
    | undefined,
): AuthorizedResourceAccessMap {
  const authorizedResourceAccess = initialState?.authorizedResourceAccess || {};

  if (initialState?.currentTenantIsAdmin) {
    return buildAdminAccessMap(authorizedResourceAccess);
  }

  return authorizedResourceAccess;
}
